import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import {isNull} from 'lodash';
import {agylePref} from '../../../../store/reducers/preferences';
import {Chip, FormLabel, Stack} from '@mui/material';
import {OPTION_BUTTONS_DEFAULT_GAP, useSettingsStyles} from '../userProperties';

const DEFAULT_STATE = {
    filtersModalOpen: false,
};

const FilterSettings = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [show, setShow] = useState(!isNull(agylePreference?.filtersModalOpen) ? agylePreference?.filtersModalOpen : DEFAULT_STATE.filtersModalOpen);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setShow(DEFAULT_STATE.filtersModalOpen);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val) => {
        setShow(val);
        props.onChange('filtersModalOpen', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default behaviour of the filter mode')}
            </FormLabel>

            <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mt: 1, my: .5}}>
                <Chip label="Open" className={clsx(show && classes.activeChip)} onClick={handleChange.bind(null, true)} />

                <Chip label="Close" className={clsx(!show && classes.activeChip)} onClick={handleChange.bind(null, false)} />
            </Stack>
        </div>
    );
});

export default FilterSettings;